/** Spoiler-free share: game name, day number, win/loss + attempts. */

import { GAME_NAME } from './pool.js';
import { MAX_LIVES, type RoundState } from './round.js';

export function shareText(state: RoundState): string {
  if (!state.ended || !state.outcome) {
    return `${GAME_NAME} #${state.day}`;
  }
  const mark = state.outcome === 'win' ? 'W' : 'L';
  const attempts = state.outcome === 'loss' ? MAX_LIVES : Math.max(1, state.attempts);
  return `${GAME_NAME} #${state.day}\n${mark} ${attempts}/${MAX_LIVES}`;
}
